import Box from '@mui/material/Box'

const DEFAULT_LOGO_SRC = '/logo-black.svg'
interface LogoProps {
    src?: string
    alt?: string
    width?: number | Partial<Record<'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl', number>>
}

const Logo = ({ src, alt, width }: LogoProps) => {
    return (
        <Box sx={{ width: width || { xs: 180, md: 220 }, maxWidth: '100%' }}>
            <img
                src={src || DEFAULT_LOGO_SRC}
                alt={alt || 'logo'}
                style={{
                    display: 'block',
                    objectFit: 'contain',
                    width: '100%',
                    height: 'auto',
                    imageRendering: '-webkit-optimize-contrast',
                }}
                width={800}
                height={400}
                decoding='async'
            />
        </Box>
    )
}

export default Logo


